import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { maxBounds, minBounds, Patterns, VALIDATIONS_TEXT } from "../../constants/Constants";
import Select, {
    components,
} from 'react-select';
import parse from 'html-react-parser';
import { ToastContainer, toast } from "react-toastify";

const allStores = [
    { value: 'wallys', label: 'Wallys' },
    { value: 'burnetrd', label: 'Burnet Rd' },
    { value: 'manorrd', label: 'Manor Rd' }
]

const colourStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            cursor: "pointer",
            backgroundColor: isDisabled ? 'red' : 'white',
            color: '#989898',
            textAlign: "left",
            ":hover": {
                backgroundColor: "#f4f4f4",
                color: "#126ADF"
            },
        }
    },
};


const AddRumbucksPopup = (props) => {
    const [disable, setDisable] = useState(false);
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        mode: "onChange"
    });

    //On Close Button function
    const handleClose = () => props?.setAddPopup(false);

    //On Save Btn function

    //On Submit function
    const onSubmit = (data) => {

        setDisable(true);

        console.log("Edit Store Link", data);


        setTimeout(function () {
            setDisable(false);
            props?.setAddPopup(false)
            toast.success('Rumbuck Has been Adeed', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }, 4000);
    }

    return (
        <>

            <Modal
                className='editModal'
                show={true}
                size="md"
                onHide={handleClose}
                centered

            >
                <Modal.Header closeButton className='border-0 p-0 mb-4'>
                    <Modal.Title className='heading-small '>Add Rumbuck</Modal.Title>
                </Modal.Header>
                <Modal.Body className='border-0 p-0'>
                    <Form onSubmit={handleSubmit(onSubmit)} className="roundedForm">
                        <div className="innerFormScroll">
                            <Row>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Employee Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Employee Name"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            maxLength={maxBounds.NAME}
                                            {...register("name", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.NAME_REQUIRED
                                                },
                                                pattern: {
                                                    value: Patterns.Name,
                                                    message: VALIDATIONS_TEXT.NAME_PATTERN
                                                },
                                                maxLength: {
                                                    value: maxBounds.NAME,
                                                    message: VALIDATIONS_TEXT.NAME_MAX
                                                }
                                            })}
                                        />
                                        {errors.name && <Form.Text>{errors.name.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Store</Form.Label>
                                        <Select
                                            className="rumSelect normal w-100"
                                            classNamePrefix="rumSelect"
                                            options={allStores}
                                            placeholder="All Stores"
                                            name="reactSelectName"
                                            {...register("store")}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={colourStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Increment</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Add Increment"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}

                                            {...register("increment", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.FIELD_REQUIRE
                                                },
                                                pattern: {
                                                    value: Patterns.ZipCode,
                                                    message: VALIDATIONS_TEXT.CVV_MAX
                                                },
                                                maxLength: {
                                                    value: maxBounds.CVV,
                                                    message: VALIDATIONS_TEXT.CVV_MAX
                                                }
                                            })}
                                        />
                                        {errors.increment && <Form.Text>{errors.increment.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="discrip">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Add Description"
                                            {...register("IncDiscription", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.SHIFT_GOAL_REQUIRED
                                                },
                                                maxLength: {
                                                    value: maxBounds.TEXTAREA,
                                                    message: VALIDATIONS_TEXT.TEXTAREA_MAX
                                                }
                                            })}
                                        />

                                        {errors.IncDiscription && <Form.Text>{errors.IncDiscription.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Decrement</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Add Decrement"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            {...register("decrement", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.FIELD_REQUIRE
                                                },
                                                pattern: {
                                                    value: Patterns.ZipCode,
                                                    message: VALIDATIONS_TEXT.CVV_MAX
                                                },
                                                maxLength: {
                                                    value: maxBounds.CVV,
                                                    message: VALIDATIONS_TEXT.CVV_MAX
                                                }
                                            })}
                                        />
                                        {errors.decrement && <Form.Text>{errors.decrement.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="discrip">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            placeholder='Add Description'
                                            rows={4}
                                            {...register("DecDiscription", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.SHIFT_GOAL_REQUIRED
                                                },
                                                maxLength: {
                                                    value: maxBounds.TEXTAREA,
                                                    message: VALIDATIONS_TEXT.TEXTAREA_MAX
                                                }
                                            })}
                                        />

                                        {errors.DecDiscription && <Form.Text>{errors.DecDiscription.message}</Form.Text>}
                                    </Form.Group>
                                </Col>

                            </Row>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Button type='submit' className="glowBtn"> {
                                !disable ? <>Save</> : <div className="load black"></div>
                            }</Button>
                        </div>
                        <ToastContainer />
                    </Form>


                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddRumbucksPopup